export default __webpack_public_path__ + "static/media/loading.157f21ba.gif";